(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["peik-product-card"] && !Shopify.designMode) return;
  try {
    if (!window.peiksCollectionCardReady) {
    window.peiksCollectionCardReady = true;

    const stockLimit = form => {
      const value = form.querySelector('select[name="id"]')?.selectedOptions[0]?.dataset.stockLimit ?? form.dataset.stockLimit;
      return value === '' || value == null ? null : Math.max(0, Number.parseInt(value, 10) || 0);
    };
    const showError = (form, message) => {
      const error = form.querySelector('.peik-card-error');
      error.textContent = message;
      error.hidden = false;
    };
    const clearError = form => {
      const error = form.querySelector('.peik-card-error');
      error.hidden = true;
      error.textContent = '';
    };


    const updateImage = (card, data, variantId) => {
      const info = card.querySelector('[data-peik-info]');
      if (!info) return;
      const href = new URL(info.dataset.productUrl, window.location.origin);
      if (variantId) href.searchParams.set('variant', variantId);
      card.querySelectorAll('.peik-card-title, .peik-card-details, .peik-card-media, .product-card__link, [ref="cardGalleryLink"]').forEach(link => {
        link.href = href.pathname + href.search;
      });
      const gallery = card.querySelector('.card-gallery');
      let image = card.querySelector('.peik-card-media img');
      if (!image && gallery && data.imageSrc) {
        let link = gallery.querySelector('.peik-card-variant-media');
        if (!link) {
          link = document.createElement('a');
          link.className = 'peik-card-variant-media';
          image = document.createElement('img');
          image.loading = 'lazy';
          image.decoding = 'async';
          link.append(image);
          gallery.append(link);
        } else {
          image = link.querySelector('img');
        }
        link.href = href.pathname + href.search;
        gallery.classList.add('peik-variant-gallery');
      }
      if (!data.imageSrc) {
        gallery?.classList.remove('peik-variant-gallery');
        gallery?.querySelector('.peik-card-variant-media')?.remove();
        return;
      }
      if (!image) return;
      if (image.getAttribute('src') !== data.imageSrc) {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = data.imageSrc;
      }
      image.alt = data.imageAlt || '';
      card.dataset.featuredMediaUrl = data.imageSrc;
    };
    const updateOffer = card => {
      const compare = card.querySelector('[data-peik-compare]');
      const onSale = Boolean(compare && !compare.hidden && compare.textContent.trim());
      card.querySelector('[data-peik-info]')?.classList.toggle('is-on-sale', onSale);
      const badge = card.querySelector('[data-peik-offer]');
      if (badge) badge.hidden = !onSale;
      card.querySelectorAll('.product-badges__badge').forEach(nativeBadge => {
        if (/^(sale|angebot)$/i.test(nativeBadge.textContent.trim())) nativeBadge.setAttribute('data-peik-native-offer', '');
      });
    };
    const initializeCards = scope => {
      const infos = [];
      if (scope.matches?.('[data-peik-info]')) infos.push(scope);
      scope.querySelectorAll?.('[data-peik-info]').forEach(info => infos.push(info));
      infos.forEach(info => {
        const card = info.closest('product-card');
        if (!card) return;
        const select = card.querySelector('.peik-card-form select[name="id"]');
        const option = select?.selectedOptions[0];
        const id = option?.value || card.querySelector('.peik-card-form input[name="id"]')?.value;
        updateImage(card, option?.dataset || info.dataset, id);
        updateOffer(card);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeCards(document), { once: true });
    else initializeCards(document);
    document.addEventListener('shopify:section:load', event => initializeCards(event.target));
    const cardObserver = new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(node => {
        if (node.nodeType === 1 && !node.matches('.peik-card-variant-media, .peik-card-variant-media *')) initializeCards(node);
      }));
    });
    cardObserver.observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('click', event => {
      const step = event.target.closest('[data-peik-step]');
      if (!step) return;
      const form = step.closest('form');
      const input = form.querySelector('[name="quantity"]');
      const amount = Number.parseInt(input.value, 10) || 1;
      const next = amount + Number(step.dataset.peikStep);
      const limit = stockLimit(form);
      const max = limit === null ? 99 : Math.min(99, limit);
      if (next > max) {
        showError(form, max > 0 ? `Nur ${max} Stück verfügbar.` : 'Aktuell nicht mehr verfügbar.');
        return;
      }
      input.value = Math.max(1, next);
      clearError(form);
    });

    document.addEventListener('input', event => {
      const input = event.target.closest?.('form[data-peik-add] input[name="quantity"]');
      if (!input || input.value === '') return;
      const form = input.closest('form');
      const limit = stockLimit(form);
      const max = limit === null ? 99 : Math.min(99, limit);
      if (Number(input.value) > max) {
        input.value = Math.max(1, max);
        showError(form, max > 0 ? `Nur ${max} Stück verfügbar.` : 'Aktuell nicht mehr verfügbar.');
      } else {
        clearError(form);
      }
    });

    document.addEventListener('change', event => {
      const select = event.target.closest('.peik-card-form select[name="id"]');
      if (!select) return;
      const option = select.selectedOptions[0];
      const card = select.closest('product-card');
      if (!card) return;
      const price = card.querySelector('[data-peik-price]');
      const compare = card.querySelector('[data-peik-compare]');
      const unit = card.querySelector('[data-peik-unit]');
      price.textContent = option.dataset.price;
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
      unit.textContent = option.dataset.unit || '';
      unit.hidden = !option.dataset.unit;
      updateImage(card, option.dataset, option.value);
      updateOffer(card);
      const form = select.closest('form');
      const quantity = form.querySelector('[name="quantity"]');
      const limit = stockLimit(form);
      quantity.max = limit === null ? '99' : String(Math.max(1, Math.min(99, limit)));
      if (Number(quantity.value) > Number(quantity.max)) quantity.value = quantity.max;
      clearError(form);
    });

    document.addEventListener('submit', async event => {
      const form = event.target.closest?.('form[data-peik-add]');
      if (!form) return;
      event.preventDefault();
      if (!form.reportValidity()) return;
      const button = form.querySelector('[type="submit"]');
      clearError(form);
      button.disabled = true;
      const originalLabel = button.textContent;

      try {
        const root = window.Shopify?.routes?.root || '/';
        const limit = stockLimit(form);
        if (limit !== null) {
          const cartResponse = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
          if (!cartResponse.ok) throw new Error('Bestand konnte nicht geprüft werden. Bitte erneut versuchen.');
          const cart = await cartResponse.json();
          const id = form.querySelector('[name="id"]').value;
          const inCart = cart.items.reduce((total, item) => total + (String(item.variant_id) === id ? item.quantity : 0), 0);
          const remaining = Math.max(0, limit - inCart);
          const requested = Number.parseInt(form.querySelector('[name="quantity"]').value, 10);
          if (requested > remaining) {
            throw new Error(remaining > 0 ? `Noch ${remaining} Stück verfügbar${inCart > 0 ? ` (${inCart} bereits im Warenkorb)` : ''}.` : 'Die verfügbare Menge liegt bereits im Warenkorb oder ist ausverkauft.');
          }
        }
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          body: new FormData(form)
        });
        if (!response.ok) {
          const result = await response.json().catch(() => ({}));
          throw new Error(result.description || 'Bitte versuche es erneut.');
        }
        button.textContent = 'Hinzugefügt ✓';
        try {
          const cartResponse = await fetch(root + 'cart.js', { credentials: 'same-origin' });
          const cart = await cartResponse.json();
          const { CartUpdateEvent } = await import('@theme/events');
          document.dispatchEvent(new CartUpdateEvent(cart, 'peiks-collection', {
            itemCount: cart.item_count,
            source: 'peiks-collection',
            sections: {}
          }));
        } catch (_) {
          // Produkt wurde hinzugefügt; nur die Kopfzeilenanzeige lässt sich
          // gegebenenfalls erst nach einem Neuladen aktualisieren.
        }
        window.setTimeout(() => {
          if (!form.isConnected) return;
          button.textContent = originalLabel;
          button.disabled = false;
        }, 1400);
      } catch (failure) {
        showError(form, failure.message || 'Bitte versuche es erneut.');
        button.disabled = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
